module.exports = __webpack_public_path__ + "img/shenqb.7de4066b.png";